import {atom} from "recoil";

export const appProfileButtonStore = atom({
  key: 'appProfileButtonStore', // unique ID (with respect to other atoms/selectors)
  default: true, // default value (aka initial value)
});